const dashboardPaths = {
  dashboard: '/dashboard',
};

export default dashboardPaths;
